
import Swiper, { Navigation, Pagination, Lazy, Autoplay} from 'swiper';
Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

import Component from 'gia/Component'

export default class PostSwiperComponent extends Component {

  constructor(element) {
    super(element);
    this.ref = {
      pagination: null,
      next: null,
      prev: null,
      fraction: null
    }
  }
  
  mount() {
    
    const opts = { 
      lazy: { 
        loadPrevNext: true, 
        loadPrevNextAmount: 4,
      }
    }

    let currentSlide = 1;
    let totalSlides = this.element.querySelectorAll('.swiper-slide').length;

    const autoplay_opt = this.element.dataset.autoplay
    const navigation_opt = this.element.dataset.navigation
    const pagination_opt = this.element.dataset.pagination 
    const progressbar_opt = this.element.dataset.progressbar 
    const spacing_opt = this.element.dataset.spacing
    const slides_opt = this.element.dataset.count
    const direction_opt = this.element.dataset.direction
    const loop_opt = this.element.dataset.loop 
    const speed_opt = this.element.dataset.speed
    const center_opt = this.element.dataset.center 
    // const code_opt = this.element.dataset.code 

    if (center_opt) {
      opts.centeredSlides = true
    }

    if (slides_opt) {
      opts.slidesPerView = parseInt(slides_opt)
    }

    if (spacing_opt) {
      opts.spaceBetween = parseInt(spacing_opt)
    }

    if (direction_opt) {
      opts.direction = direction_opt
    }

    if (loop_opt) {
      opts.loop = true
    }

    if (speed_opt) { 
      opts.speed = parseInt(speed_opt)
    }

    if (pagination_opt) { 
      opts.pagination = {
        el: this.ref.pagination,
        clickable: true,
      }
    }

    if(progressbar_opt) {
      opts.pagination.type = "progressbar";
      let default_slides = 2;
      let default_spacing = 16;
      if(slides_opt) {
        default_slides = parseInt(slides_opt)
      }
      if(spacing_opt) {
        default_spacing = parseInt(spacing_opt);
      }
      opts.slidesPerView = 1;
      opts.spaceBetween = default_spacing;
      opts.breakpoints = {
        768: {
          slidesPerView: default_slides,
          spaceBetween: default_spacing
        }
      }

      // opts.on = {
      //   slideChange: () => {
      //       this.ref.fraction.textContent = `${swiper.realIndex + 1} / ${totalSlides}`;
      //   }
      // }
      // this.ref.fraction.textContent = `1 / ${totalSlides}`;

    }
 
    if (navigation_opt) {
      opts.navigation = {
        nextEl: this.ref.next,
        prevEl: this.ref.prev
      }
    }

    if (autoplay_opt) {
      opts.autoplay = {
        delay: parseInt(autoplay_opt)
      }
    }
    // console.log(JSON.parse(code_opt));
    
    const swiper = new Swiper(this.element, opts);
 
  }
}



